"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAPICallTimestampByKey = exports.selectAPICallTimestamp = exports.selectAPICallState = exports.selectAPICallMultiple = exports.selectAPICall = exports.getCallKey = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _reselect = require("reselect");
var _packageIndex = require("../../package-index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EMPTYSTATE = {};
const getCalls = state => state.calls;
const getCallMetadata = state => state.call_metadata;
const getCallKey = (__, apiName, args) => {
  let api = (0, _packageIndex.getAPIFn)(apiName);
  return api.urlFunction(...(args || []));
};
exports.getCallKey = getCallKey;
const getCallKeys = (__, calls) => _lodash.default.map(calls, call => {
  let api = (0, _packageIndex.getAPIFn)(call.apiName);
  return api.urlFunction(...(call.args || []));
});
const selectAPICall = exports.selectAPICall = (0, _reselect.createSelector)([getCalls, getCallKey], (calls, callKey) => calls[callKey] && calls[callKey].value);
const selectAPICallTimestamp = exports.selectAPICallTimestamp = (0, _reselect.createSelector)([getCallMetadata, getCallKey], (callMeta, callKey) => callMeta[callKey] && callMeta[callKey].timestamp);
const selectAPICallTimestampByKey = exports.selectAPICallTimestampByKey = (0, _reselect.createSelector)([getCallMetadata, (__, callKey) => callKey], (callMeta, callKey) => callMeta[callKey] && callMeta[callKey].timestamp);
const selectAPICallState = exports.selectAPICallState = (0, _reselect.createSelector)([getCalls, getCallKey], (calls, callKey) => calls[callKey] && calls[callKey].state);
const selectAPICallMultiple = exports.selectAPICallMultiple = (0, _reselect.createSelector)([getCalls, getCallKeys], (calls, callKeys) => _lodash.default.map(callKeys, callKey => {
  return !calls || calls[callKey] === undefined ? EMPTYSTATE : calls[callKey];
}));